export const API = import.meta.env.VITE_API_BASE_URL;

export function getCsrfToken() {
  try {
    const raw = localStorage.getItem("fungistics-profile");
    return raw ? JSON.parse(raw)._csrf : "";
  } catch {
    return "";
  }
}

export async function apiFetch(path, options = {}) {
  const method = (options.method || "GET").toUpperCase();
  const isMutating = method !== "GET" && method !== "OPTIONS";

  const headers = { ...(options.headers || {}) };
  if (isMutating) {
    headers["X-CSRF-Token"] = getCsrfToken();
  }

  const res = await fetch(`${API}${path}`, {
    credentials: "include",
    ...options,
    headers,
  });

  if (!res.ok) {
    let body = {};
    try { body = await res.json(); } catch { /* ignore parse failures */ }
    const err = new Error(body.error || `${path} ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}
